import apiSlice from "./ApiSlice";

const productApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllProductData: builder.query({
      providesTags: ["product"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/product",
          method: "POST",
          body,
        };
      },
    }),
    getAllExcelData: builder.query({
      providesTags: ["product"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/excel",
          method: "POST",
          body,
        };
      },
    }),
    getAllProduct: builder.query({
      providesTags: ["product"],
      query: () => {
        return {
          url: "/product",
          method: "GET",
        };
      },
    }),

    // delete delivery date
    deleteProductById: builder.mutation({
      invalidatesTags: ["product"],
      query: (id: any) => ({
        url: `/product/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addProduct: builder.mutation({
      invalidatesTags: ["product"],
      query: (body) => ({
        url: `/product/add`,
        method: "POST",
        body,
      }),
    }),
    getProductFilterDataForFilter: builder.mutation({
      query: (body) => ({
        url: `/product/filter`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getProductById: builder.query({
      providesTags: ["product"],
      query: (id) => {
        return {
          url: `/product/admin/${id}`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateProductById: builder.mutation({
      invalidatesTags: ["product"],
      query: ({ body, id }) => ({
        url: `/product/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // change status of delivery date
    changeStatusProductById: builder.mutation({
      invalidatesTags: ["product"],
      query: ({ body, id }) => ({
        url: `/product/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
    //sync products by api
    createSynkProductByAPI: builder.mutation({
      invalidatesTags: ["product"],
      query: () => ({
        url: `/product/sync-products`,
        method: "POST",
      }),
    }),
    uploadExcel: builder.mutation({
      invalidatesTags: ["product"],
      query: (body) => ({
        url: `/product/add`,
        method: "POST",
        body,
      }),
    }),
    getDownloadErrorExcel: builder.query<Blob, string>({
      query: (id) => ({
        url: `/excel/download-err-file/${id}`,
        method: "GET",
        responseHandler: async (response: any) => await response.blob(),
        responseType: "blob",
      }),
    }),
    getProductExcelDownload: builder.query<Blob, string>({
      query: () => ({
        url: `/product/download-product-excel-file`,
        method: "GET",
        responseHandler: async (response: any) => await response.blob(),
        responseType: "blob",
      }),
    }),
  }),
});

export const {
  useGetAllProductDataQuery,
  useGetAllExcelDataQuery,
  useDeleteProductByIdMutation,
  useAddProductMutation,
  useGetProductByIdQuery,
  useUpdateProductByIdMutation,
  useChangeStatusProductByIdMutation,
  useCreateSynkProductByAPIMutation,
  useGetAllProductQuery,
  useGetProductFilterDataForFilterMutation,
  useUploadExcelMutation,
  useLazyGetDownloadErrorExcelQuery,
  useLazyGetProductExcelDownloadQuery
} = productApi;
